import React from 'react';

import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../components/form/form-field';
import SaveButton from '../../../components/form/save-button';

const InsertForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;

  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      {/* <FormField
        controlId="insertFormDataType"
        label="type"
        name="@data-type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        defaultValue="dataframe"
        readOnly
        error={errors["@data-type"]?.message}
        disabled
      /> */}
      <FormField
        controlId="insertFormAction"
        label="action"
        name="action"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        defaultValue="insert"
        readOnly
        disabled
        error={errors.action?.message}
      />
      <FormField
        controlId="insertFormDataFrame"
        label="data-frame"
        name="data-frame"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        required
        error={errors['data-frame']?.message}
      />
      <FormField
        controlId="insertFormQuery"
        label="query"
        name="query"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.SPARKQL}
        rows={10}
        required
        error={errors.query?.message}
      />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default InsertForm;
